import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useHostConfig } from '../../../hooks/use-host-config'
import { Header } from '@Components/header/header'
import { ImageBackgroundSection } from '@Components/image-background-section/image-background-section'
import { FormFloatingFooter } from '@Components/claim-flow/form-floating-footer'
import { Button } from '@Components/button/button'
import { ClaimReservationActions } from '@AppState/claim-reservation'
import { ContainerMessenger } from '../../../container-messenger/container-messenger'
import { ContainerMessageType } from '../../../container-messenger/types'

import './claim-form-confirmation.scss'

const CLASS_NAME = 'claim-form-confirmation'

export const ClaimFormConfirmation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const hostConfig = useHostConfig()
  const confirmationConfig = hostConfig.claimFormConfig?.confirmation

  const handleDone = () => {
    ContainerMessenger.sendMessage({ type: ContainerMessageType.EXIT, payload: {} })
    dispatch(ClaimReservationActions.clearSavedReservation())
    navigate(`/create${location.search}`)
  }

  return (
    <>
      <Header title="Submitted!" />
      <section className={CLASS_NAME}>
        {confirmationConfig?.backgroundImage && (
          <ImageBackgroundSection backgroundUrl={confirmationConfig.backgroundImage}>
            <h1 className={`${CLASS_NAME}__title`}>{confirmationConfig?.title ?? 'Submitted!'}</h1>
          </ImageBackgroundSection>
        )}
        {confirmationConfig?.heroImage && (
          <section className={`${CLASS_NAME}__hero`}>
            <img
              src={confirmationConfig.heroImage}
              alt="Claim form submitted"
              className={`${CLASS_NAME}__hero-image`}
            />
          </section>
        )}
        <section className={`${CLASS_NAME}__message`}>
          <h2>Thank you!</h2>
          {confirmationConfig?.message ?? <p>Your claim form has been successfully submitted.</p>}
        </section>
        <FormFloatingFooter>
          <section className="floating-footer__buttons">
            <Button className="floating-footer__next-button" disabled={false} onClick={handleDone}>
              Done
            </Button>
          </section>
        </FormFloatingFooter>
      </section>
    </>
  )
}
